import apiService from './api';
import { ENDPOINTS } from '../constants/apiEndpoints';

export const bookingService = {
  async createBooking(data) {
    return apiService.post(ENDPOINTS.BOOKINGS_CREATE, data);
  },

  async createWwooferBooking(data) {
    return apiService.post(ENDPOINTS.BOOKINGS_WWOOFER_CREATE, data);
  },

  async getUserBookings(userId) {
    return apiService.get(ENDPOINTS.BOOKINGS_USER(userId));
  },

  async acceptBooking(bookingId) {
    return apiService.post(ENDPOINTS.BOOKING_ACCEPT(bookingId));
  },

  async cancelBooking(bookingId) {
    return apiService.post(ENDPOINTS.BOOKING_CANCEL(bookingId));
  },

  async editBookingDates(bookingId, dates) {
    return apiService.put(ENDPOINTS.BOOKING_EDIT_DATES(bookingId), dates);
  },
};
